module.exports = __webpack_public_path__ + "img/chartjs.741fa8e3.png";